import { render, staticRenderFns } from "./HeroBannerController.vue?vue&type=template&id=0c4e5d40&scoped=true"
import script from "./HeroBannerController.vue?vue&type=script&lang=js"
export * from "./HeroBannerController.vue?vue&type=script&lang=js"
import style0 from "./HeroBannerController.vue?vue&type=style&index=0&id=0c4e5d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4e5d40",
  null
  
)

export default component.exports